import React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import Home from './ui/routes/Home';
import Login from './ui/routes/Login';
import Validate from './ui/routes/Validate';
import { default as ConsoleContainer } from './ui/container/Console';
import Logout from './ui/routes/Logout';
import KeyManagement from './ui/views/KeyManagement';
import Execution from './ui/views/Execution';
import Requests from './ui/views/Requests';
import Users from './ui/views/Users';
import { SessionConsumer } from './ui/components/SessionProvider';
import LoadingSession from './ui/views/LoadingSession';
import queryString from 'query-string';
import Footer from 'sm-react-components/build/components/Footer';
import * as routes from './infrastructure/routemap';
import { configuration } from './infrastructure/configuration';
import FreshChat from 'react-freshchat';


const Router = () => (

    <BrowserRouter>
        <Switch>
            <PublicRoute exact path={routes.root} component={Home} />
            <PublicRoute path={routes.register} component={() => <Login route={'register'} />} />
            <PublicRoute path={routes.resetPassword} component={() => <Login route={'reset-password'} />} />
            <PublicRoute path={routes.login} component={(match) => <Login route={'login'} queryString={queryString.parse(match.location.search)} />} />
            <PublicRoute path={routes.userValidation} component={({ match }) => <Validate token={match.params.token} />} />
            <PublicRoute path={routes.userNewPassword} component={({ match }) => <Login route={'reset-password'} token={match.params.token} />} />
            <Route path={routes.logout} component={Logout} />
            <PrivateRoute path={routes.console.activityExecution} component={({ match }) => (
                <ConsoleContainer section={'Requests'} back={routes.console.requests}>
                    <Execution id={match.params.id} />
                </ConsoleContainer>
            )} />
            <PrivateRoute path={routes.console.requests} component={() => (
                <ConsoleContainer section={'Requests'}>
                    <Requests />
                </ConsoleContainer>
            )} />
            <PrivateRoute path={routes.console.key} component={({ match }) => (
                <ConsoleContainer section={'Keys'} back={routes.console.keys}>
                    <KeyManagement keyId={match.params.id} />
                </ConsoleContainer>
            )} />
            <PrivateRoute path={routes.console.keys} component={() => (
                <ConsoleContainer section={'Keys'} >
                    <KeyManagement />
                </ConsoleContainer>
            )} />
            <PrivateRoute allowedRoles={['admin']} path={routes.console.users} component={({ match }) => (
                <ConsoleContainer section={'Users'} >
                    <Users />
                </ConsoleContainer>
            )} />
            <PrivateRoute path={routes.console.root} component={() => <Redirect to={routes.console.keys} />} />
        </Switch>
    </BrowserRouter>
);

const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            <SessionConsumer>
                {({ user, ready, loggedIn }) => {
                    if (!ready) {
                        return <LoadingSession />;
                    } else if (!loggedIn) {
                        return <Redirect
                            to={{
                                pathname: routes.publicDefaultRoute,
                                state: { from: props.location }
                            }}
                        />;
                    }

                    if ((allowedRoles === undefined || allowedRoles.length === 0) ||
                        user.roles.indexOf(allowedRoles[0])
                    ) {
                        return (
                            <React.Fragment>
                                <div style={{ minWidth: 'min-content' }}>
                                    <div style={{ position: 'relative', minHeight: '100vh' }}>
                                        <Component {...props} />
                                        <FreshChat
                                            token={configuration.FRESHCHAT_TOKEN}
                                            onInit={widget => {
                                                widget.user.setProperties({
                                                    email: user.email,
                                                    externalId: user.id,
                                                    restoreId: user.id,
                                                    first_name: user.firstName,
                                                    last_name: user.lastName,
                                                    phone: user.phone,
                                                    company: user.company,
                                                    siteId: 'flake.smartmonkey.io',
                                                });
                                            }}
                                        />
                                    </div>
                                    {/* <Hidden mdDown>
                                        <Footer compact />
                                    </Hidden> */}
                                </div>
                            </React.Fragment>
                        );
                    } else {
                        return <Redirect
                            to={{
                                pathname: routes.privateDefaultRoute,
                                state: { from: props.location }
                            }}
                        />;
                    }
                }}
            </SessionConsumer>
        }
    />
);

const PublicRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            <SessionConsumer>
                {({ user, ready, loggedIn }) => {
                    if (!ready) {
                        return <LoadingSession />;
                    } else if (loggedIn) {
                        return <Redirect
                            to={{
                                pathname: routes.privateDefaultRoute,
                                state: { from: props.location }
                            }}
                        />;
                    }
                    return <React.Fragment>
                        <div style={{ minHeight: '80vh' }}>
                            <Component {...props} />
                            <FreshChat
                                token={configuration.FRESHCHAT_TOKEN}
                                onInit={widget => {
                                    widget.user.setProperties({
                                        siteId: 'flake.smartmonkey.io',
                                    });
                                }}
                            />
                        </div>
                        <Footer
                            firstColumn={[
                                { text: 'Blog', actionHandler: () => window.open('https://blog.smartmonkey.io') }
                            ]}
                            secondColumn={[
                                { text: 'Support', actionHandler: () => window.open('https://docs.smartmonkey.io') }
                            ]}
                            thirdColumn={[
                                { text: 'Home', actionHandler: () => window.open('https://smartmonkey.io') }
                            ]} /></React.Fragment>;
                }}
            </SessionConsumer>
        }
    />
);

export default Router;